import {
    mapSalesChannelsForOne,
    mapSalesChannelsForList,
} from './common';

function mapGetOneCollateralDigitalAssetData(responseData) {
    return {
        ...responseData,
        ...mapSalesChannelsForOne(responseData),
    };
}

function mapGetListCollateralDigitalAssetsData(responseData) {
    return responseData.map((data) => ({
        ...data,
        ...mapSalesChannelsForList(data),
    }));
}

export { mapGetOneCollateralDigitalAssetData, mapGetListCollateralDigitalAssetsData };
